"use client";

import { Text } from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";

import SideMenuGroup from "./side-menu-group";
import { useSideMenu, UseSideMenuProps } from "./use-side-menu";

export type SideMenuProps = UseSideMenuProps;

function SideMenu(props: SideMenuProps) {
  const {
    className,
    styles,
    name,
    menu,
    onToggleDropdown,
    activeSection,
    onHandleOpenSideMenu,
    WrapperEl,
    onHandleMenu,
  } = useSideMenu(props);

  return (
    <WrapperEl
      className={styles.base({ className })}
      data-component-name="side-menu"
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      exit={{ x: "-100%" }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 30,
        duration: 0.3,
      }}
    >
      <div className={styles.wrapper()}>
        <div className={styles.headerMobile()}>
          <Button
            type="button"
            color="black"
            size="md"
            onClick={() => onHandleOpenSideMenu?.(false, "")}
          >
            <Icon name="chevron_left" className="!w-4 !h-4" />
            <span className={styles.titleMobile()}>{name}</span>
          </Button>
        </div>
        <nav className={styles.nav()}>
          <Text tag="h2" size="titleHatMedium" className={styles.title()}>
            {name}
          </Text>
          <ul className={styles.menu()}>
            {menu.map((item) => (
              <SideMenuGroup
                key={item.id}
                data={item}
                styles={styles}
                onToggleDropdown={onToggleDropdown}
                activeSection={activeSection}
                onHandleMenu={onHandleMenu}
              />
            ))}
          </ul>
        </nav>
      </div>
    </WrapperEl>
  );
}

export default SideMenu;
